import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
export const navBarHeight = 54;
export const StyledNavigationTabBar = styled.ul.withConfig({
  displayName: "NavigationTabBarstyles__StyledNavigationTabBar",
  componentId: "sc-1iyqcct-0"
})(["display:flex;align-items:center;height:", "px;top:0;background-color:", ";"], navBarHeight, Colors.DARK_202020);